import { render } from "./Link.vue?vue&type=template&id=5089aac8"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5089aac8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5089aac8', script)) {
    api.reload('5089aac8', script)
  }
  
  module.hot.accept("./Link.vue?vue&type=template&id=5089aac8", () => {
    api.rerender('5089aac8', render)
  })

}

script.__file = "src/icons/components/filled/Link.vue"

export default script